import { Config } from "../../../api/config";
export var FieldFailureReportsKeys = {
    Paging: 'FieldFailureReportsPaging',
    create: 'FieldFailureReportsCreate',
    update: 'FieldFailureReportsPagingUpdate',
    get: 'FieldFailureReportsDetailsGetById',
    count: 'FieldFailureReportsCount',
    ManualSearchGetData: "FieldFailureReportsManualSearch",
    tempCondList: 'TemperatureConditionList',
    download: 'FieldFailureReportsDownload',
    GetWarrantyList: 'GetWarrantyListData',
    upload: 'FieldFailureReportAttachment',
    getValue: 'getAttachmentValue' //attachment upload
};
export var appoinmentPagingURL = "".concat(Config.baseURL, "/Appointment/Paging");
export var FFRCreate = "".concat(Config.baseURL, "FieldFailureReport");
// export const appointmentPagingURL = `${Config.baseURL}/Appointment/Paging`
export var fieldFailureReportsPagingURL = "".concat(Config.baseURL, "FieldFailureReport/Paging");
export var fieldFailureReportsDownloadURL = function (data) { return "".concat(Config.baseURL).concat(data.URL, "/").concat(data.DocumentId, "/").concat(data.AttachmentId); };
export var fieldFailureReportsManualSearchURL = "".concat(Config.baseURL, "Installbase/SearchByVinNumber");
export var fieldFailureReportsDetailGetByIdAPI = function (id) { return "".concat(Config.baseURL, "FieldFailureReport/").concat(id, "/Get"); };
export var fieldFailureReportsDetailUpdateByIdAPI = function (id) { return "".concat(Config.baseURL, "FieldFailureReport/").concat(id, "/Update"); };
export var fieldFailureReportsWarrantyPartDetails = function (id) { return "".concat(Config.baseURL, "FieldFailureReport/").concat(id, "/GetWarrantyPartDetails"); };
export var fieldFailureReportsTemperatureConditionsListAPI = "".concat(Config.baseURL, "TemperatureConditions/List");
export var fieldFailureReportCreateAttachment = "".concat(Config.baseURL, "FieldFailureReportAttachment/Create");
export var fieldFailureAttachmentSingleValue = function (id, schemaId) { return "".concat(Config.baseURL, "resource/").concat(schemaId, "/").concat(id); };
export var fieldFailureReportSubmit = function (id) { return "".concat(Config.baseURL, "FieldFailureReport/").concat(id, "/Submit"); };
export var fieldFailureReportsDetailCreate = "".concat(Config.baseURL, "FieldFailureReport/Create");
export var getPartListUrl = "".concat(Config.baseURL, "Product/PricePartList");
export var getBranchListUrl = "".concat(Config.baseURL, "Organization/AllBranchesByParentId");
export var repairTypeListURL = "".concat(Config.baseURL, "ServiceType/ListByPostingType");
